import React from 'react'
import { Link, Container, styled, useMediaQuery } from '@mui/material'

const PREFIX = 'MobileMenu'

const classes = {
  root: `${PREFIX}-root`,
  button: `${PREFIX}-button`,
}

const styles = ({ theme }) => ({
  [`&.${classes.root}`]: {
    padding: theme.spacing(2),
  },
  [`& .${classes.button}`]: {
    marginRight: theme.spacing(2),
    fontWeight: 700,
  },
})

const StyledContainer = styled(Container)(styles)

function MobileMenu() {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'))
  return (
    isMobile && (
      <StyledContainer className={classes.root}>
        <Link
          target="_blank"
          rel="noopener"
          href="https://www.m1.com.sg/Support/FAQ/prepaid-faq"
          className={classes.button}
        >
          FAQ
        </Link>
        <Link
          target="_blank"
          rel="noopener"
          href="https://www.m1.com.sg/Mobile/prepaid-plans"
          className={classes.button}
        >
          M1 website
        </Link>
      </StyledContainer>
    )
  )
}

export default MobileMenu
